.paste-options-widget {
  position: fixed;
  z-index: 15010;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &__trigger {
    display: flex;
    align-items: center;
    gap: 2px;
    padding: 3px 5px;
    background: var(--sbb-color-white);
    border: 1px solid var(--sbb-color-granite);
    border-radius: 3px;
    cursor: pointer;
    font-size: 15px;
    color: var(--sbb-color-anthracite);
    user-select: none;

    &:hover {
      background: var(--sbb-color-milk);
      border-color: var(--sbb-color-iron);
    }

    .ms-Icon {
      font-size: 16px;
      pointer-events: none;
    }

    .paste-options-widget__caret {
      font-size: 8px;
      margin-top: 1px;
      pointer-events: none;
    }
  }

  &__menu {
    display: flex;
    flex-direction: row;
    margin-top: 2px;
    padding: 4px 6px;
    background: var(--sbb-color-white);
    border: 1px solid var(--sbb-color-cloud);
    border-radius: 3px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    gap: 2px;
  }

  &__action {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border: 1px solid transparent;
    border-radius: 2px;
    background: none;
    cursor: pointer;
    color: var(--sbb-color-anthracite);
    font-size: 16px;
    padding: 0;

    &:hover {
      background: var(--sbb-color-milk);
      border-color: var(--sbb-color-iron);
    }

    &--active {
      background: var(--sbb-color-milk);
      border-color: var(--sbb-color-iron);
    }

    .ms-Icon {
      pointer-events: none;
    }
  }

  &__separator {
    width: 1px;
    background: var(--sbb-color-cloud);
    margin: 3px 4px;
    align-self: stretch;
  }
}
